import * as Y from "yjs";

export function isUnsupportedCapability(status: number): boolean {
  return status === 404 || status === 501;
}

function bytes(base64: string): Uint8Array {
  return Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
}

/** A durable vector must cover every clock visible in this tab. */
export function durableVectorCovers(serverVector: string, localVector: Uint8Array): boolean {
  if (!serverVector) return false;
  try {
    const remote = Y.decodeStateVector(bytes(serverVector));
    for (const [client, clock] of Y.decodeStateVector(localVector)) {
      if ((remote.get(client) ?? 0) < clock) return false;
    }
    return true;
  } catch {
    return false;
  }
}
